import {useDispatch, useSelector} from 'react-redux'
import {connect} from 'react-redux'
import {useEffect, useState, useRef} from 'react'
import {useLocation, useHistory} from 'react-router-dom'
import {Button} from 'react-bootstrap'
import Modal from 'react-modal'
import ReactTooltip from 'react-tooltip'
import {Application, DatePicker} from 'react-rainbow-components'
import DefaultCard from '../../../assets/img/default-card.png'
import American from '../../../assets/img/american-logo.png'
import Diners from '../../../assets/img/diners-logo.png'
import Magna from '../../../assets/img/magna-logo.png'
import Mastercard from '../../../assets/img/mastercard-logo.png'
import Redcompra from '../../../assets/img/redcompra-logo.png'
import Visa from '../../../assets/img/visa-logo.png'
import ModalUploadHome from '../../../Components/Modals/ModalUploadHome'
import ModalSelectPaymentMethod from '../../../Components/Modals/ModalSelectPaymentMethod'
import Location from '../../../Components/Location'
import Toasts from '../../../Components/Toasts/Toasts'
import SimpleSelect from '../../../Components/Forms/SimpleSelect'
import ModalBottomSimple from '../../../Components/Modals/ModalBottomSimple'
import ModalError from '../../../Components/Modals/ModalError'
import ModalBeneficiaries from '../../../Components/Modals/ModalBeneficiaries'

import Stepper from '../../../Components/Stepper'
import * as Sentry from '@sentry/react'
import {setCopayUserData, setInsurance} from '../../../redux/modules/user'

import {
  logEvent,
  addEventNameWithParams,
  encrypt,
  normalizeRut,
  decrypt,
} from '../../../Utils/utils'
import {
  acceptedFileTypes,
  deliveryFrequencies,
  subscriptionTypes,
  base_url,
} from '../../../Utils/constants'
import {Viewer, Worker, SpecialZoomLevel} from '@react-pdf-viewer/core'
import loadingYapp from '../../../assets/img/yapp_loading.gif'
import {
  addCreditCard,
  getCreditCard,
  getCreditCardResult,
  getSubscriptionDiscountByCode,
  createSubscription,
  sendToPay,
  uploadFile,
  getInsuranceLiquidation,
  getBeneficiaries,
} from '../../../Utils/api'
import {
  setGoRouter,
  setLocation,
  changeLogo,
  showLogo,
  setThemeColor,
  setFormData,
  setPrescriptions,
  setApplicationNumber,
  setEnabledInsurance,
} from '../../../redux/modules/app'
import {
  getShoppingCart,
  createPreOrder,
  saveShoppingCart,
  getComplementaryCart,
  removeShoppingCart,
} from '../../../Utils/service'
import {getKeyObject} from '../../../Utils/storage'
import {
  getJWTdata,
  _formatPrice,
  _formatRut,
  getHash,
  _validateRut,
  _validateMail,
  _validPhone,
  formatDate,
  encode64,
  getLocationTool,
  _getDv,
  _capitalize,
  base64MimeType,
  _isWeekEnd,
} from '../../../Utils/tools'

import ModalUploader from '../../../Components/Modal.Uploader'
import ProductPrescription from '../../../Components/ShoppingBag/ProductPrescription'
import ProductSummary from '../../../Components/ShoppingBag/ProductSummary'
import ProductSupplementary from '../../../Components/ShoppingBag/ProductSupplementary'
import ModalLegal from '../../../Components/ShoppingBag/ModalLegal'
import LoadingCheckout from '../../../Components/ShoppingBag/LoadingCheckout'

import ButtonYapp from '../../../Components/Buttons/ButtonYapp'
import Input from '../../../Components/Forms/Input'
import InputButtonDiscount from '../../../Components/Forms/InputButtonDiscount'
import InputButton from '../../../Components/Forms/InputButton'
import SelectPaymentMethod from '../../../Components/Forms/SelectPaymentMethod'
import SelectInsurance from '../../../Components/Forms/SelectInsurance'
import LoadingSura from '../../../Components/Loading/LoadingSura'
import LoadingScreen from 'react-loading-screen'
import useScreenSize from '../../../Hooks/useScreenSize'

import {setContext} from '@sentry/react'
import TypeSidetab from '../../../Components/TypeForm/TypeSidetab'
import farmaciaFacil from '../../../assets/img/farmacia-facil.png'
import icErrorPay from '../../../assets/img/error_pay.svg'

const clientName = process.env.REACT_APP_CLIENT_NAME  || 'Yapp Chile'
const tokenLogin = process.env.REACT_APP_EXTERNAL_VALID_TYPE === 'API'
const isInsurance = process.env.REACT_APP_PROFILE === 'INSURANCE'
const isInsuranceEnabled = process.env.REACT_APP_ENABLED_INSURANCE === 'TRUE'

const _ = require('lodash')
const moment = require('moment-timezone')

function ShoppingBagCheckout(props) {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [hasComplementary, setHasComplementary] = useState(false)
  const [complementaryDelivery, setComplementaryDelivery] = useState(null)
  const [products, setProducts] = useState([])
  const [productsComplementary, setProductComplementary] = useState([])
  const [creditCards, setCreditCards] = useState([])

  const [totalCart, setTotalCart] = useState(0)
  const [total, setTotal] = useState(0)
  const [totalComplementaryCart, setTotalComplementaryCart] = useState(0)
  const [delivery, setDelivery] = useState({cost: 0})
  const [deliveryDiscount, setDeliveryDiscount] = useState(null)
  const [date, setDate] = useState(new Date())
  const [minDate, setMinDate] = useState(new Date())
  const [deliveryTime, setDeliveryTime] = useState(null)
  const [modalDocument, setModalDocument] = useState(false)
  const [openModalError, setOpenModalError] = useState(false)
  const [openModalBeneficiaries, setOpenModalBeneficiaries] = useState(false)
  const [benefit, setBenefit] = useState(null)

  const [otherDocuments, setOtherDocuments] = useState([])
  const userInfo = useSelector((state) => state.user.userInfo)
  const prescriptionProduct = useSelector(
    (state) => state.app.prescriptions || [],
  )
  const [purchase, setPurchase] = useState(false)
  const [discount, setDiscount] = useState(null)
  const [deductible, setDeductible] = useState(0)
  const [discountCode, setDiscountCode] = useState(null)
  const [applyRefund, setApplyRefund] = useState(false)
  const [errorRefund, setErrorRefund] = useState(false)
  const [clientDiscountBenefits, setClientDiscountBenefits] = useState(0)

  const [applyDiscount, setApplyDiscount] = useState(false)
  const [addNewCard, setAddNewCard] = useState(false)
  const [insurancePolicyLimit, setInsurancePolicyLimit] = useState(false)
  const [insuranceError, setInsuranceError] = useState(false)
  const [refund, setRefund] = useState({})
  const [pressedButton, setPressedButton] = useState(false)
  const [showAlert, setShowAlert] = useState(false)

  const [formError, setFormError] = useState({})
  const [errorPrescription, setErrorPrescription] = useState(false)
  const [errorPhoneEmpty, setErrorPhoneEmpty] = useState(false)
  const [errorPhoneFormat, setErrorPhoneFormat] = useState(false)
  const [errorEmail, setErrorEmail] = useState(false)
  const [errorCheckTerms, setErrorCheckTerms] = useState(false)

  const [sending, setSending] = useState(false)
  const [modalErrorPayIsOpen, setModalErrorPayIsOpen] = useState(false)
  const [stateToasts, setStateToasts] = useState(true)
  const [invalidDate, setInvalidDate] = useState(null)
  const [invalidDateMessage, setInvalidDateMessage] = useState(null)
  const [invalidFrequency, setInvalidFrequency] = useState(false)
  const [beneficiaries, setBeneficiaries] = useState([])
  const [chainBusinessName, setChainBusinessName] = useState('la farmacia')
  const [chainIdentityNumber, setChainIdentityNumber] = useState(null);

  const [isSubscription, setIsSubscription] = useState(false)
  const [frequency, setFrequency] = useState(null)
  const [showModalPaymentMethod, setShowModalPaymentMethod] = useState(false)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(false)
  const [loading, setLoading] = useState(true)
  const [loadingConfirmBuy, setLoadingConfirmBuy] = useState(null)
  const [loadingGlobal, setLoadingGlobal] = useState(false)

  const [item, setItem] = useState(null)
  const [errorCode, setErrorCode] = useState(null)

  const [showPdf, setShowPdf] = useState(false)
  const [pdfToShow, setPdf] = useState('')

  const [defaultCodeForDiscount, setDefaultCodeForDiscount] = useState('')

  const [showModalBottomSimple, setShowModalBottomSimple] = useState(false)
  const [disabledButtonPay, setDisabledButtonPay] = useState(false)

  const locationStorage = useSelector((state) => state.app.location)
  const userStorage = useSelector((state) => state.user)
  const [updatedPrescription, setUpdatedPrescription] = useState([])
  const textExtraPrescription = useSelector(
    (state) => state.app.text_extra_prescription,
  )

  const deliveryCode = useSelector((state) => state?.delivery?.delivery_code)

  const refundElement = useSelector((state) => state.app.refund_element)
  const textSubscriptionCheckout = useSelector(
    (state) => state.app.text_subscription_checkout,
  )
  const isUserYapp =
    userInfo?.profile?.uid && userInfo?.signInMethod !== 'anonymously'
      ? true
      : false

  const modalRef = useRef()
  const params = new URLSearchParams(location.search)
  const paymentSubscriptionId = params.get('subscriptionId')
  const [loadingInsurance, setLoadingInsurance] = useState(false)
  const [showInsurance, setShowInsurance] = useState(isInsurance || isInsuranceEnabled)
  const [titleInsurance] = useState(isInsurance ? 'Datos del paciente' : 'Datos del Seguro complementario')
  const [insuranceDiscountId] = useState(
    ![null,undefined,''].includes(props?.insurance?.insurance_discount_id)
      ? props.insurance.insurance_discount_id
      : null
  )

  const [isStyleLight, setIsStyleLight] = useState(
    process.env.REACT_APP_BORDER === 'LIGHT',
  )

  const handleDeliveryDate = (locationNextDate) => {
    let day = moment.utc(locationNextDate).date()
    let month = moment.utc(locationNextDate).month()
    let year = moment.utc(locationNextDate).year()
    let minDeliveryDate = new Date(year, month, day)
    let today = new Date()

    minDeliveryDate = minDeliveryDate.getTime() < today.getTime() ? today : minDeliveryDate
    setMinDate(minDeliveryDate)
    setDate(minDeliveryDate)
  }

  const { width } = useScreenSize()

  useEffect(async () => {
    try {
      if (clientName === 'UC Christus') {
        let router = []
        router.push(
          {
            go: 'https://www.ucchristus.cl/yapp',
            target: '_blank',
            description: 'Red de Salud UC CHRISTUS',
          },
          {
            go: '/search',
            from: '',
            description: 'Buscador de medicamentos',
          },
          {
            go: '/shopping_bag/quotation',
            title: 'Checkout',
            description: 'Cotización de medicamentos',
          },
        )
        dispatch(props.setGoRouter(router))
      }
    } catch (ignore) {}
    if (
      userInfo?.profile?.uid &&
      paymentSubscriptionId &&
      userInfo?.signInMethod !== 'anonymously'
    ) {
      let creditCardSubscription = await getCreditCardResult(
        paymentSubscriptionId,
      )
      if (creditCardSubscription?.status === 'success') {
        logEvent('Payment Method Added', {
          Added: 'True',
        })
        setAddNewCard(true)
        getPaymentMethod()
      } else {
        logEvent('Payment Method Added', {
          Added: 'False',
        })
        console.error('Credit card subscription error')
      }
    }

    setLoading(false)
  }, [window.location.href])

  useEffect(() => {
    if (props.formData) {
      setDisabledButtonPay(
        [undefined, null, ''].includes(props.formData.location_name.value) ||
          [undefined, null, ''].includes(
            props.formData.location_number.value,
          ) ||
          [undefined, null, ''].includes(props.formData.full_name.value) ||
          [undefined, null, ''].includes(props.formData.phone.value) ||
          !_validateRut(props.formData.rut.value) ||
          !_validateMail(props.formData.email.value) ||
          isUserYapp
          ? false
          : !props.formData.checkTerms.value,
      )
    }
  }, [props.formData])

  useEffect(() => {
    if (props.disabledThemeCheckout === true) {
      dispatch(setApplicationNumber(null))
      dispatch(changeLogo(null))
      dispatch(showLogo(false))
      dispatch(
        setThemeColor({
          primary: '#6578FF',
          secondary: '#4DBAB6',
        }),
      )
    }

    if (isInsurance) {
      let clientId = process.env.REACT_APP_CLIENT_ID
      setLocalInsurance(clientId)
      dispatch(
        setInsurance(props?.insuranceList?.filter((c) => c.id === clientId)[0]),
      )
      if (
        ![null, undefined, ''].includes(
          props?.formData?.titular_identity?.value,
        )
      ) {
        dispatch(setEnabledInsurance(true))
      }
    }
  }, [])

  useEffect(async () => {
    if (userInfo?.profile?.uid && userInfo?.signInMethod !== 'anonymously') {
      getPaymentMethod()
    }
  }, [userInfo])

  useEffect(() => {
    if (isInsurance &&
      props?.formData?.titular_identity?.value === '' &&
      props?.formData?.rut?.value) 
    {
      checkInsuranceUser(props.formData.rut?.value)
    }
  }, [props.formData.rut])

  useEffect(async () => {
    if (pressedButton) {
      onClickApplyRefund()
      setShowAlert(false)
    }
  }, [updatedPrescription])

  useEffect(() => {
    props.setFormData({
      ...props.formData,
      location_name: {
        ...props.formData.location_name,
        value: props.location?.label,
      },
    })
  }, [props.location])

  useEffect(() => {
    let localData = getKeyObject('LOCAL_DATA', 'client_config')
    let localDataSite = getKeyObject('LOCAL_DATA', 'site')

    let userData = sessionStorage.getItem('USER_DATA')

    setDeliveryTime(_.get(localData, 'delivery_time', null))

    userData = JSON.parse(userData)
    let email = _.get(
      localDataSite,
      'info.email',
      _validateMail(userData?.email)
        ? userData?.email
        : _validateMail(userStorage?.email)
        ? userStorage?.email
        : '',
    )

    props.setFormData({
      ...props.formData,
      location_name: {
        ...props.formData.location_name,
        value: ![undefined, null, ''].includes(
          props.formData.location_name.value,
        )
          ? props.formData.location_name.value
          : locationStorage?.label,
      },
      location_number: {
        ...props.formData.location_number,
        value: ![undefined, null, ''].includes(
          props.formData.location_number.value,
        )
          ? props.formData.location_number.value
          : locationStorage?.nro,
      },
      email: {
        ...props.formData.email,
        value: ![undefined, null, ''].includes(props.formData.email.value)
          ? props.formData.email.value
          : email,
      },
      full_name: {
        ...props.formData.full_name,
        value: ![undefined, null, ''].includes(props.formData.full_name.value)
          ? props.formData.full_name.value
          : userData?.name,
      },
      rut: {
        ...props.formData.rut,
        value: ![undefined, null, ''].includes(props.formData.rut.value)
          ? props.formData.rut.value
          : _formatRut(userData?.identity),
      },
      phone: {
        ...props.formData.phone,
        value: ![undefined, null, ''].includes(props.formData.phone.value)
          ? props.formData.phone.value
          : _validPhone(userData?.phone)
          ? userData?.phone
          : '',
      },
      discount: ![undefined, null, ''].includes(props.formData.discount)
        ? props.formData.discount
        : null,
      address_additional: {
        ...props.formData.address_additional,
        value: ![undefined, null, ''].includes(
          props.formData.address_additional.value,
        )
          ? props.formData.address_additional.value
          : [undefined, null, ''].includes(userData?.address_additional)
          ? ''
          : ' ' + userData.address_additional,
      },
      checkTerms: {
        ...props.formData.checkTerms,
        valid: isUserYapp ? true : props.formData.checkTerms.value,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationStorage])

  // Load user data.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    let userData = sessionStorage.getItem('USER_DATA')

    if (userData) {
      userData = JSON.parse(userData)

      if (userData?.address) {
        let location = await getLocationTool(userData?.address)
        let communeFilter = props.communes?.filter(
          (el) => el.name === location.locality,
        )
        if (communeFilter?.length > 0) {
          dispatch(setLocation({...location, commune_id: communeFilter[0].id}))
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    let item = localStorage.getItem('selectedQuotationItem')

    if (item) {
      item = JSON.parse(item)
      setItem(item)
      
      if ( item.default_code?.length ) { // Si recibimos un codigo de descuento por defecto, lo aplicaremos
        setDefaultCodeForDiscount(item.default_code)
      }

      let remoteBag = await getShoppingCart()
      if (remoteBag) {
        let quotationDetail = item?.quotation_detail
        // let hasFreeShipping = false
        handleDeliveryDate( item?.delivery?.next_date )

        let total = 0
        await updateProducts(quotationDetail, remoteBag)
        let count = 0
        quotationDetail = quotationDetail.map((el) => {
          let idx = _.findIndex(remoteBag, {product_id: el.product.product_id})
          if (idx >= 0) {
            el.counter = remoteBag[idx].counter
            el.client_benefit = remoteBag[idx].client_benefit || 0
            el.client_benefit_pharmacy = remoteBag[idx].client_benefit_pharmacy || 0
            el.product.client_product_id =
              [undefined, null, ''].includes(
                remoteBag[idx]?.client_product_id,
              ) && remoteBag[idx]?.id

            if (
              !['', null, undefined].includes(el?.product?.client_product_id)
            ) {
              el.product.count = count
              count++
            }

            let productTotal = el.price * remoteBag[idx].counter

            total = total + productTotal
          }

          return el
        })
        let loadIsSubscription = item?.is_subscription ? true : false

        setIsSubscription(loadIsSubscription)
        if (showInsurance) {
          setShowInsurance(!loadIsSubscription)
        }
        setDelivery(item?.delivery)
        if (deliveryCode?.code && (refund?.value > 0 || deductible > 0)) {
          setDeliveryDiscount(
            item?.delivery.cost > 0
              ? (deliveryCode.value * item?.delivery.cost) / 100
              : item?.delivery.cost,
          )
        }

        setTotalCart(total)
        setTotal(total)
        setProducts(quotationDetail)

        if (
          props.formData.discount &&
          item?.is_subscription &&
          item.quotation_detail?.length > 0 &&
          props.formData.discount.subscription_product_id ===
            item.quotation_detail[0].subscription_product_id
        ) {
          setDiscount(props.formData.discount)
          setDiscountCode(props.formData.discount.discount_code)
        }
      } else {
        console.log('Error al obtener la bolsa remota.')
      }
    } else {
      console.log('Error al recibir la cotización seleccionada.')
    }
    dispatch(setLocation(null))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Effect to load Complementary Products
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    let dataComplementary = await getComplementaryCart()
    setComplementaryCartValues(dataComplementary)
  }, [])

  useEffect(() => {
    if (otherDocuments.length > 0) {
      clickGenerateLink()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otherDocuments])

  const setCounter = (index, quantity) => {
    let newProducts = [...products]
    newProducts[index].counter = quantity

    setProducts(newProducts)
    setTotalCart(newProducts[index].price * quantity)
    setTotal(newProducts[index].price * quantity)
  }

  async function updateProducts(quotation, remoteBag) {
    let productToUpdate = quotation.filter((el) => el?.product_id_old)
    for (const key in productToUpdate) {
      if (Object.hasOwnProperty.call(productToUpdate, key)) {
        const element = productToUpdate[key]
        // Update remoteBag
        let idx = _.findIndex(remoteBag, {product_id: element.product_id_old})
        if (idx !== -1) {
          remoteBag[idx] = {
            ...remoteBag[idx],
            ...{
              counter: element.quantity,
              formula_name: element?.product.formula_name,
              product_id: element?.product.product_id,
              product_logo: element?.product.logo,
            },
          }
        }
      }

      await saveShoppingCart(remoteBag)
    }
  }

  function goBack() {
    dispatch(setLocation(null))
    history.push('/shopping_bag/quotation')
  }

  function changeValue(value, key) {
    let valid = value !== ''

    if (['rut', 'titular_identity'].includes(key)) {
      value = _formatRut(value)
      valid = _validateRut(value)
    }

    if (key === 'phone') {
      if (value.trim() !== '' && isNaN(value)) {
        valid = false
      }
    }

    if (key === 'email') {
      if (props.formData.phone.value.length === 0 && !errorPhoneEmpty) {
        setErrorPhoneEmpty(true)
      }
      valid = _validateMail(value)
    }

    if (key === 'full_name') {
      if (value?.trim() !== '' && isNaN(value)) {
        valid = false
      }
    }

    setFormError({...formError, [key]: true})
    props.setFormData({
      ...props.formData,
      [key]: {...props.formData[key], value: value, valid},
    })
  }

  function onClickLoadPrescription(productId, products) {
    logEvent('Prescription Opened')
    modalRef.current.showAlert({productId, products, prescriptionProduct})
  }

  async function checkInsuranceUser(identity) {
    try {
      let response = await getBeneficiaries(props?.formData?.rut?.value, props.insurance?.id)

      if (response?.data?.listBeneficiaries?.length > 0) {
        let userData = response.data.listBeneficiaries.find((beneficiary) =>
          _formatRut(beneficiary.identity) === _formatRut(identity.toUpperCase())
        )
        userData && onClickBenefit(userData)
      }
    }
    catch (err) {
      console.log('Failed to get insurance user')
    }
  }

  async function setPrescriptionProduct(event) {
    let tmp = prescriptionProduct
    setErrorPrescription(false)
    if (Array.isArray(tmp)) {
      logEvent('Prescription Added', {
        Quantity: event?.productsChecked?.length,
      })
      event.productsChecked.map((productId) => {
        if (!tmp.some((el) => el.product_id === productId)) {
          tmp.push({
            product_id: productId,
            image: event.images[0],
            b64: event.images,
          })
        }

        dispatch(setPrescriptions([...tmp]))
        setUpdatedPrescription([...tmp])
      })
    }
  }

  async function deleteProductItem(itemSel) {
    const newProducts = products.filter((el) => el.product.product_id !== itemSel.product.product_id)
    let item = localStorage.getItem('selectedQuotationItem')
    if (item) {
      item = JSON.parse(item)
      setItem(item)
    }

    let subtotal = _.sumBy(
      newProducts,
      (product) =>
        product.price * product.quantity,
    )
    let total = subtotal + item.delivery.cost

    let newItem = {
      ...item,
      quantity_products: newProducts.length,
      quantity_results: newProducts.length,
      quotation_detail: newProducts,
      total: total - deliveryDiscount,
      total_order: total
    }

    localStorage.setItem('selectedQuotationItem', JSON.stringify(newItem))
    await saveShoppingCart(newProducts)

    setTotalCart(subtotal)
    setTotal(subtotal)
    setProducts(newProducts)
  }

  function getStatusform() {
    setErrorCheckTerms(isUserYapp ? false : !props.formData.checkTerms.value)
    return {
      ...props.formData,
      location_name: {
        ...props.formData.location_name,
        valid: ![undefined, null, ''].includes(
          props.formData.location_name.value,
        ),
      },
      location_number: {
        ...props.formData.location_number,
        valid: ![undefined, null, ''].includes(
          props.formData.location_number.value,
        ),
      },
      address_additional: {...props.formData.address_additional, valid: true},
      full_name: {
        ...props.formData.full_name,
        valid: ![undefined, null, ''].includes(props.formData.full_name.value),
      },
      rut: {
        ...props.formData.rut,
        valid: _validateRut(props.formData.rut.value),
      },
      email: {
        ...props.formData.email,
        valid: _validateMail(props.formData.email.value),
      },
      checkTerms: {
        ...props.formData.checkTerms,
        valid: isUserYapp ? true : props.formData.checkTerms.value,
      },
      discount: {...props.formData.discount, valid: true},
    }
  }

  function addProducts() {
    history.replace('/search/shopping_bag/000000')
  }

  function requestPrescription(order) {
    let request = false
    if (
      props.config?.required_prescription === true &&
      ![null, undefined].includes(order?.product?.client_product_id)
    ) {
      return true
    }
    if (
      props.config?.required_prescription === true ||
      (order.product?.prescription_id > 0 && !order.is_subscription) ||
      order.prescription_id > 0
    ) {
      request = true
    }
    return request
  }

  async function uploadPrescription() {
    let jwtData = getJWTdata()

    let prescriptions = prescriptionProduct.filter((p) =>
      products.find(
        (el) =>
          p?.product_id == el?.product?.product_id ||
          p?.product_id == el?.product?.client_product_id,
      ),
    )
    if (jwtData) {
      let uploadResult = []

      let tmp =
        props.documents_pending === true && otherDocuments.length > 0
          ? prescriptions.concat(otherDocuments)
          : prescriptions

      let prepareUpload = await Promise.all(
        tmp
          .filter((c) => !c?.external)
          .map(async (el) => {
            let mime = base64MimeType(el?.image)
            let image = await fetch(el?.image).then((res) => res.blob())

            let fileType = acceptedFileTypes.includes(mime?.type?.split('/')[1])
              ? mime?.type?.split('/')[1]
              : null
            let fileName =
              encode64(
                new Date().toISOString() + (mime?.name ? mime.name : ''),
              ) +
              '.' +
              fileType

            return {
              file_name: fileName,
              product_id: el.product_id,
              image: image,
            }
          }),
      )

      uploadResult = tmp.filter((c) => c?.external).map((el) => el)

      for (const key in prepareUpload) {
        if (Object.hasOwnProperty.call(prepareUpload, key)) {
          const item = prepareUpload[key]

          let resp = null
          let existUploaded = uploadResult.some(
            (el) => el.file_name === item.file_name,
          )
          if (!existUploaded) {
            try {
              let formData = new FormData()
              formData.append('bucket', 's3.yapp')
              formData.append(
                'filepath',
                'img/prescription/webapp' + item.file_name,
              )

              formData.append('file', item.image, item.file_name)
              resp = await uploadFile(formData)
            } catch (error) {
              console.log(error)
            }
          } else {
            resp = {
              location: uploadResult.find(
                (el) => el.file_name === item.file_name,
              )?.url,
            }
          }

          if (resp?.location) {
            uploadResult.push({
              product_id: item.product_id,
              file_name: item.file_name,
              url: resp?.location,
            })
          }
        }
      }

      return uploadResult
    } else {
      console.log('Error JWT Data.')
      return false
    }
  }

  function setComplementaryCartValues(payload) {
    setProductComplementary(payload)
    let totalComplementary = 0
    for (const key in payload) {
      if (Object.hasOwnProperty.call(payload, key)) {
        const element = payload[key]
        totalComplementary =
          totalComplementary + element.price * element.quantity
      }
    }

    setTotalComplementaryCart(totalComplementary)
  }

  async function addPaymentMethod() {
    logEvent('Payment Method Checked')

    setLoading(true)
    let currentUrl = window.location.href
    if (currentUrl.includes('subscriptionId=')) {
      let subscriptionIndex = currentUrl.lastIndexOf('subscriptionId=')
      currentUrl = currentUrl.substr(0, subscriptionIndex)
    }

    let userData = {
      email: userInfo.profile.email,
      userId: userInfo.profile.uid,
      callbackUrl: window.location.href,
    }

    let addPaymentMethodUrl = await addCreditCard(userData)
    if (addPaymentMethodUrl?.data) {
      logEvent('Payment Method Redirected', {
        Redirected: 'True',
      })

      window.location.href = addPaymentMethodUrl.data
    } else {
      logEvent('Payment Method Redirected', {
        Redirected: 'False',
      })
      console.error('Payment method redirection url error')
    }
  }

  function setPaymentLogo(cardType) {
    let logo = DefaultCard
    switch (cardType.toLowerCase()) {
      case 'visa':
        logo = Visa
        break
      case 'master':
        logo = Mastercard
        break
      case 'dinner':
        logo = Diners
        break
      case 'magna':
        logo = Magna
        break
      case 'amex':
        logo = American
        break
      case 'redcompra':
        logo = Redcompra
        break
      default:
        break
    }
    return logo
  }

  function setPaymentMethod(selectedCardId) {
    let creditCardList = []
    for (let card of creditCards) {
      card.used = card.id === selectedCardId ? 1 : 0
      creditCardList.push(card)
      card.used && setSelectedPaymentMethod(card)
    }
    setCreditCards(creditCardList)
  }

  function setLocalInsurance(insuranceId) {
    let insuranceFilter = props?.insuranceList?.filter(
      (c) => c.id === insuranceId,
    )
    if (insuranceFilter?.length > 0) {
      if (insuranceFilter[0].id === null) {
        dispatch(setEnabledInsurance(false))
      }
      dispatch(setInsurance(insuranceFilter[0]))
    }
  }

  async function getPaymentMethod() {
    let creditCardList = await getCreditCard(userInfo.profile.uid)
    let selectedCard = null

    if (creditCardList?.data?.length > 0) {
      for (let card of creditCardList.data) {
        card.logo = setPaymentLogo(card.type)
        if (card.default === 1) {
          selectedCard = card
          card.used = 1
        } else {
          card.used = 0
        }
      }

      if (!selectedCard) {
        selectedCard = creditCardList.data[0]
        creditCardList.data[0].used = 1
      }

      setCreditCards(creditCardList.data)
      setSelectedPaymentMethod(selectedCard)
    }
  }

  function showInsuranceOptions() {
    let options = null

    if (props?.insuranceList?.length > 0) {
      options = props?.insuranceList.map((insurance, i) => ({
        label: (
          <div className={'d-flex align-items-center ml-4'} key={i.toString()}>
            <div className="d-flex justify-content-start align-items-start w-25 my-1">
              {insurance.logo ? (
                <img src={insurance.logo} alt={'Logo ' + insurance.name} />
              ) : (
                <p className="txt-5--regular-db text-right mt-2 mb-2">
                  {insurance.name}
                </p>
              )}
            </div>
          </div>
        ),
        value: insurance.id,
      }))
    }
    return options
  }

  function showPaymentOptions() {
    let options = null
    if (creditCards?.length > 0) {
      options = creditCards.map((card, i) => ({
        label: (
          <div
            className={
              'd-flex align-items-center ml-4' +
              (card.used ? ' payment-method-active' : '')
            }
            style={{width: '90px'}}
            key={i.toString()}>
            <div className="d-flex justify-content-center align-items-center w-75">
              <img
                className="payment-logo"
                src={card.logo}
                alt="Logo método de pago"
              />
            </div>
            <p className="txt-5--regular-db text-right">{card.last_four}</p>
          </div>
        ),
        value: card.id,
      }))
    }
    return options
  }

  function showDefaultPaymentOption() {
    let option = null
    if (selectedPaymentMethod) {
      option = {
        label: (
          <div
            className={'d-flex align-items-center ml-4'}
            style={{width: '90px'}}
            key={0}>
            <div className="d-flex justify-content-center align-items-center w-75">
              <img
                className="payment-logo"
                src={selectedPaymentMethod.logo}
                alt="Logo método de pago"
              />
            </div>
            <p className="txt-5--regular-db text-right">
              {selectedPaymentMethod.last_four}
            </p>
          </div>
        ),
        value: selectedPaymentMethod.id,
      }
    }

    return option
  }

  const checkDeliveryDate = (newDate) => {
    if (_isWeekEnd(newDate)) {
      setInvalidDateMessage(
        'Lo sentimos, no contamos con despacho los fines de semana.',
      )
      setInvalidDate('weekend')
    } else if (
      props.holidayList.some((holiday) => holiday === formatDate(newDate))
    ) {
      setInvalidDateMessage('Lo sentimos, debes seleccionar un día hábil.')
      setInvalidDate('holiday')
    } else {
      setInvalidDateMessage('')
      setDate(newDate)
      setInvalidDate(false)
    }
  }

  function showDefaultInsuranceOption() {
    let option = null
    if (props?.insurance) {
      option = {
        label: (
          <div
            className={'d-flex align-items-center ml-4'}
            key={props?.insurance?.id?.toString()}>
            <div className="d-flex justify-content-start align-items-start w-25">
              {props?.insurance.logo ? (
                <img
                  src={props?.insurance.logo}
                  alt={'Logo ' + props?.insurance.name}
                />
              ) : (
                <p className="txt-5--regular-db text-right mt-2 mb-2">
                  {props?.insurance.name}
                </p>
              )}
            </div>
          </div>
        ),
        value: props?.insurance.id,
      }
    }
    return option
  }

  async function clickNextAction() {
    if (isSubscription) {
      if ([undefined, null, ''].includes(frequency)) {
        setInvalidFrequency(true)
        return
      } else {
        setInvalidFrequency(false)
      }
    }
    setLoadingGlobal(true)

    if (
      Object.values(getStatusform()).some((el) => el.valid === false) ||
      !validatePrescription() ||
      errorPhoneEmpty ||
      errorPhoneFormat ||
      sending ||
      loading ||
      disabledButtonPay
    ) {
      setLoadingGlobal(false)
      /*  */
      let data = {}

      for (var key in props.formData) {
        data[key] = false
      }

      setFormError({...formError, ...data})
      return
    }

    if (props.documents_pending === true && otherDocuments.length <= 0) {
      setLoadingGlobal(false)
      return setModalDocument(true)
    }

    if (productsComplementary?.length > 0) {
      setLoadingGlobal(false)
      clickGenerateLink()
    } else if (hasComplementary) {
      setLoadingGlobal(false)
      modalSupplement.current.openModal()
    } else if (isSubscription) {
      setLoadingGlobal(false)
      let validForm = checkForm()
      validForm && onCreateSubscription()
    } else {
      setLoadingGlobal(false)
      clickGenerateLink()
    }
  }

  const clickGenerateLink = async () => {
    try {
      setPurchase(true)
      let hash = await getHash()
      modalSupplement.current.closeModal()

      if (
        _.get(locationStorage, 'label', '') === '' ||
        _.get(props.formData, 'location_number.value', '') === ''
      ) {
        setPurchase(false)
        return props.setFormData({
          ...props.formData,
          location_name: {
            ...props.formData.location_name,
            value: locationStorage?.label,
            valid: false,
          },
        })
      }

      let validationFormData = getStatusform()
      props.setFormData(validationFormData)

      if (Object.values(validationFormData).some((el) => el.valid === false)) {
      } else {
        // Email validation
        if (!_validateMail(props.formData.email.value)) {
          setPurchase(false)
          return setErrorEmail(true)
        }
        // Phone value validation
        if (props.formData.phone.value.length === 0) {
          setPurchase(false)
          return setErrorPhoneEmpty(true)
        }
        // Phone format validation
        if (!_validPhone(props.formData.phone.value)) {
          setPurchase(false)
          return setErrorPhoneFormat(true)
        }
        // Products prescription validation
        if (!validatePrescription()) {
          setPurchase(false)
        }

        const jwtData = getJWTdata()

        setSending(true)
        setLoadingConfirmBuy(true)

        let productsObj = products.map((el) => {
          return {
            product_id: el.product.product_id,
            product_refund: el?.product?.refund || null,
            product_discount: el?.product_discount || 0,
            benefit: el?.benefit || 0,
            discount_id: el?.discount_id || 0,
            price_id: el.price_id,
            price: el.price,
            quantity: el.counter,
          }
        })

        let productsComplementaryObj = productsComplementary.map((el) => {
          return {
            product_id: el.product_id,
            product_refund: null,
            product_discount: 0,
            benefit: 0,
            discount_id: 0,
            price_id: el.price_id,
            price: el.price,
            quantity: el.quantity,
          }
        })

        let paymentCard = null
        if (selectedPaymentMethod) {
          paymentCard = {
            token: selectedPaymentMethod.id,
            last_four: selectedPaymentMethod.last_four,
            card_type: selectedPaymentMethod.type,
          }
        }
        let copayData = {}
        try {
          copayData = JSON.parse(decrypt(props?.userData))
        } catch (e) {}
        let prescriptions = await uploadPrescription()

        let region = props?.location?.region
        let address = _.get(locationStorage, 'label', '') + (region && `, ${region}`)
        let locationNumber = _.get(props.formData, 'location_number.value', '')
        locationNumber = locationNumber === '' ? locationNumber : `. Nº: ${locationNumber}`
        let additionalNumber = _.get(props.formData, 'address_additional.value', '')
        additionalNumber = additionalNumber === '' ? additionalNumber : `, Otro: ${additionalNumber}`

        let currentAddress = `${address}${locationNumber}${additionalNumber}`
        let currentDelivery = {
          delivery_discount_code: deliveryCode?.code || null,
          address: {
            description: (currentAddress).trim(),
            lat: locationStorage?.lat,
            lng: locationStorage?.lng,
          },
          commune_id: locationStorage?.commune_id,
          delivery_at: formatDate(date),
        }

        let sendData = {
          hash: hash,
          user: {
            user_id: jwtData?.user_id,
            identity: props.formData.rut.value,
            name: props.formData.full_name.value,
            phone: props.formData.phone.value,
            email: props.formData.email.value,
          },
          products: productsObj,
          products_complementary: productsComplementaryObj,
          pharmacy_chain_id: item.pharmacy_chain_id,
          payment_card: paymentCard,
          payment_token: '',
          delivery: currentDelivery,
          prescriptions: prescriptions,
          refundId: refund?.id ? encrypt(refund?.id) : null,
          refund: refund?.value ? encrypt(refund.value) : null,
          deductible: deductible,
          insurance_discount_id: insuranceDiscountId,
          holder_identity: copayData?.identity_titular
            ? normalizeRut(copayData?.identity_titular)
            : null,
          beneficiary_identity: copayData?.identity
            ? normalizeRut(copayData?.identity)
            : null,
          relationship: copayData?.relationship ? copayData?.relationship : null,
          policy: copayData?.policy_id ? encrypt(copayData?.policy_id) : null,
        }

        addEventNameWithParams('checkout_product_to_pay', {
          ...sendData,
          hash: hash,
          product_cart_price: totalCart,
          complementary_product_cart_price: totalComplementaryCart,
          delivery_cost: delivery?.cost,
          complementary_delivery_cost:
            totalComplementaryCart > 0 ? complementaryDelivery?.cost : 0,
        })

        await createPreOrder(sendData, selectedPaymentMethod)

        let respPay = null
        let returnUrl = base_url + `/shopping_bag/checkout/${hash}`

        if (!selectedPaymentMethod) {
          try {
            respPay = await sendToPay(hash, returnUrl)
            if (respPay) {
              if (respPay?.data?.return_url) {
                returnUrl = respPay?.data?.return_url
              } else {
                returnUrl = respPay.data?.trx_response?.redirectUrl
              }
            }
          } catch (ignore) {
            logEvent('Payment Method Redirected', {
              Redirected: 'FALSE',
            })
            setLoadingConfirmBuy(false)
            setPurchase(false)
          }
        }

        if (selectedPaymentMethod || respPay) {
          logEvent('Payment Method Redirected', {
            Redirected: 'TRUE',
          })
          window.location.href = returnUrl
        } else {
          setPurchase(false)
          setModalErrorPayIsOpen(true)
        }
      }
    } catch (error) {
      setLoadingConfirmBuy(false)
      setPurchase(false)
    }
  }

  function validatePrescription() {
    let requiredPrescriptionProducts = products.filter(
      (el) => el.product?.prescription_id > 0,
    )
    let productWithPrescriptions = requiredPrescriptionProducts.filter((el) => {
      let product = prescriptionProduct.find(
        (p) =>
          p?.product_id == el?.product?.product_id ||
          p?.product_id == el?.product?.client_product_id,
      )
      if (![undefined, null, ''].includes(product)) {
        return (
          el?.product?.product_id == product?.product_id ||
          el?.product?.client_product_id === product?.product_id
        )
      } else {
        return false
      }
    })

    if (
      requiredPrescriptionProducts?.length !== productWithPrescriptions?.length
    ) {
      setErrorPrescription(true)
      return false
    }
    return true
  }

  async function onCreateSubscription() {
    let formData = getStatusform()
    let result = false

    try {
      setLoadingConfirmBuy(true)
      let prescriptions = await uploadPrescription()
      const jwtData = getJWTdata()

      let selectedProducts = products.filter(
        (productItem) => productItem.counter > 0,
      )
      let subscriptionAddress = locationStorage.label
      let subscriptionInfo = Object.assign({}, item)
      let productList = []
      let discountList = []

      for (const productItem of selectedProducts) {
        let product = {
          type: subscriptionTypes.special,
          product_id: productItem.product.product_id,
          subscription_product_id: productItem.subscription_product_id,
          pharmacy_chain_id: subscriptionInfo.pharmacy_chain_id,
          quantity: productItem.counter,
        }
        productList.push(product)
      }

      if (discount?.discount_value) {
        discountList.push(discount)
      }

      if (
        formData?.location_number?.value &&
        formData.location_number.value !== ''
      ) {
        subscriptionAddress += ', N°' + formData.location_number.value
      }
      if (
        formData?.address_additional?.value &&
        formData.address_additional.value !== ''
      ) {
        subscriptionAddress += '. ' + formData.address_additional.value
      }

      let subscription = {
        origin: 'yapp_web',
        user_id: jwtData?.user_id,
        payment_id: selectedPaymentMethod.id,
        pharmacy_chain_id: subscriptionInfo.pharmacy_chain_id,
        first_delivery: formatDate(date),
        delivery_cost: delivery.cost,
        customer: {
          name: formData.full_name.value,
          tax_id: formData.rut.value,
          address: subscriptionAddress,
          address_id: null,
          address_latitude: locationStorage?.lat,
          address_longitude: locationStorage?.lng,
          commune: locationStorage?.locality,
          phone: '+56' + formData.phone.value,
          comment: '',
        },
        prescription_files: prescriptions,
        products: productList,
        discounts: discountList,
        frequency: frequency.value,
        map_order: 0,
      }

      result = await saveSubscription(subscription)
    } catch (err) {
      setLoadingConfirmBuy(false)
      setPurchase(false)
    } finally {
      if (result) {
        window.location.href = result
      } else {
        setLoadingConfirmBuy(false)
      }
    }
  }

  async function saveSubscription(subscription) {
    let productQuantity = products[0].counter
    let productPrice = products[0].price
    let redirect = base_url + `/shopping_bag/subscription?result=`
    let result = 'error'
    let subscriptionId = 0

    try {
      const response = await createSubscription(subscription)
      if (response?.data?.length > 0 && response.data[0].subscriptionId) {
        subscriptionId = response.data[0].subscriptionId
        localStorage.removeItem('selectedQuotationItem')
        await removeShoppingCart()
        result = 'success'
      }
    } catch (ignore) {}

    redirect += result
    let totalOrder = 0
    let totalCarValue = 0
    try {
      totalOrder =
        productQuantity * productPrice +
        subscription.delivery_cost -
        getCurrentDiscount()
    } catch (ignore) {}

    try {
      totalCarValue = productQuantity * productPrice
    } catch (ignore) {}

    logEvent('Order Completed', {
      'Order Success': result === 'success' ? true : false,
      'Total Cart Value': totalCarValue,
      'Total Cart Size': productQuantity,
      'Total Discounts': getCurrentDiscount(),
      'Promo Code Applied': discountCode,
      'Total Shipping': subscription?.delivery_cost,
      'Order Total': totalOrder,
      'Pharmacy Id': subscription?.pharmacy_chain_id,
      'Pharmacy Name': subscription?.pharmacy_chain_name,
      'Subscription Id': subscriptionId,
      'Purchase Type': 'Benefit Yapp',
    })

    if (result === 'success') {
      logEvent('Product Purchased', {
        'Product Quantity': productQuantity,
        'Subscription Id': subscriptionId,
        'Product Name': products[0]?.product?.name,
        'Product Id': products[0]?.product?.product_id,
        'Lab Name': products[0]?.product?.lab,
        'Product Price': products[0]?.price,
        'Total Price': totalCarValue,
        'Total Discounts': getCurrentDiscount(), // TODO: Discount for that product?
        'Active Principle Name': products[0]?.product?.formula_name,
      })
    }

    return redirect
  }

  const onUseDiscountCode = async () => {
    try {
      setLoadingConfirmBuy(true)
      let result = null
      let errorMessage = 'Código inválido'

      if (![null, undefined, ''].includes(discountCode)) {
        result = await getDiscountValue(discountCode, 0)
        if (result?.discount_value) {
          result.discount_code = discountCode
          errorMessage = null
          if (products?.length > 0) {
            result.subscription_product_id = products[0].subscription_product_id
          }
          logEvent('Discount Code Applied', {
            Discount: discountCode,
            Applied: true,
            'Discount Type': 'Yapp Benefit Code',
            'Product Id': products[0]?.product?.product_id,
            'Product Name': products[0]?.product?.name,
            'Lab Name': products[0]?.product?.laboratory_name,
            'Active Principle Name':
              products[0]?.product?.active_principle_name,
            'Active Principle Id': products[0]?.product?.active_principle_id,
            'User Id': userInfo?.profile?.uid,
          })
          setApplyDiscount(true)
        } else if (result?.discount_message) {
          logEvent('Discount Code Applied', {
            Discount: discountCode,
            Applied: false,
            'Discount Type': 'Yapp Benefit Code',
            'Product Id': products[0]?.product?.product_id,
            'Product Name': products[0]?.product?.name,
            'Lab Name': products[0]?.product?.laboratory_name,
            'Active Principle Name':
              products[0]?.product?.active_principle_name,
            'Active Principle Id': products[0]?.product?.active_principle_id,
            'User Id': userInfo?.profile?.uid,
          })

          errorMessage = result.discount_message
        }

        setDiscount(result)
        setErrorCode(errorMessage)

        props.setFormData({
          ...props.formData,
          discount: result,
        })
      }
    } catch (ignore) {
    } finally {
      setLoadingConfirmBuy(false)
    }
  }

  const getDiscountValue = async (code, productWithDiscount) => {
    let userId = getJWTdata()?.user_id
    let subscriptionProductId =
      products[productWithDiscount].subscription_product_id
    let municipality = locationStorage?.locality
    let deliveryCost = delivery?.cost ? delivery.cost : 0
    let identity = props.formData.rut?.value ? props.formData.rut.value : null
    let result = null

    try {
      const response = await getSubscriptionDiscountByCode(
        userId,
        identity,
        subscriptionProductId,
        municipality,
        deliveryCost,
        totalCart,
        code,
      )
      if (response?.data?.length > 0) result = response.data[0]
    } catch (ignore) {}
    return result
  }

  const getCurrentDiscount = () => {
    const currentDiscount = discount?.discount_value
      ? discount?.discount_value || 0
      : 0
    return currentDiscount
  }

  const setProductDiscountBenefits = (productList) => {
    let currentPharmacyChain = item.pharmacy_chain_id
    let totalDiscountBenefits = 0

    try {
      if (![null, undefined,'FALSE'].includes(process.env.REACT_APP_CLIENT_BENEFIT)) {
        for (let product of productList) {
          let refundedProduct = product?.product

          if (([null, undefined, 0].includes(refundedProduct?.refund)) 
            && product?.client_benefit > 0 && product?.client_benefit_pharmacy === currentPharmacyChain) {
            product.discount_id = parseInt(process.env.REACT_APP_CLIENT_BENEFIT_ID)
            product.product_discount = ((product.counter * product.price) * product.client_benefit) /100
            product.benefit = 1
            totalDiscountBenefits += product.product_discount
          }
        }
        setClientDiscountBenefits(totalDiscountBenefits)
      }
    }
    catch (err) {
      console.log('Error getting client discount benefits', err)
    }
    finally {
      setProducts(productList)
    }

    return totalDiscountBenefits
  }

  function checkForm() {
    setPurchase(true)
    const customerForm = getStatusform()
    props.setFormData(customerForm)
    let isValidForm = !Object.values(customerForm).some(
      (data) => data.valid === false,
    )
    if (!validatePrescription()) {
      isValidForm = false
    }
    if (!isUserYapp) {
      if (customerForm.checkTerms.value === false) {
        setErrorCheckTerms(true)
        isValidForm = false
      }
    }

    if (customerForm.phone.value.length === 0) {
      setErrorPhoneEmpty(true)
      isValidForm = false
    } else if (!_validPhone(customerForm.phone.value)) {
      setErrorPhoneFormat(true)
      isValidForm = false
    }

    if (!isValidForm) setPurchase(false)
    return isValidForm
  }

  function handleCheckTermsChange(event) {
    setErrorCheckTerms(!event.target.checked)

    props.setFormData({
      ...props.formData,
      checkTerms: {
        ...props.formData.checkTerms,
        value: isUserYapp ? true : event.target.checked,
      },
    })
  }
  const retryModal = () => {
    setSending(false)
    setModalErrorPayIsOpen(false)
  }

  function setDocuments(documents) {
    setModalDocument(false)
    if (documents.length > 0) {
      setOtherDocuments(documents)
    }
  }

  function closeModalDocuments() {
    setModalDocument(false)
    setSending(false)
    setLoadingConfirmBuy(false)
  }

  function removeErrorsPhone() {
    setErrorPhoneEmpty(false)
    setErrorPhoneFormat(false)
  }
  function removeErrorEmail() {
    setErrorEmail(false)
  }

  async function onClickApplyRefund() {
    let refundSearch = true
    try {
      setPressedButton(true)
      setShowAlert(true)
      setLoadingInsurance(true)
      setInsuranceError(false)
      setErrorRefund(false)

      let productAux = products.map((el) => ({
        ...el,
        loadedPrescription:
          requestPrescription(el) && loadedPrescription(el).length === 0,
      }))

      productAux.forEach((product) => {
        if (product.loadedPrescription) {
          setApplyRefund(false)
          setErrorRefund(true)
          setStateToasts(true)
        }
      })

      let productList = productAux
        .map((p, i) => ({
          id: p.product.internal_product_id,
          name: p.product.name,
          category_id: p.product.client_product_id,
          quantity: p.quantity,
          unit: p.price,
          total: p.price * p.quantity,
        }))
      if (productList?.length <= 0) {
        setProducts(productAux)
        setRefund({})
        setDeductible(0)
        setErrorRefund(true)
        setStateToasts(true)
        return
      }

      if (productAux.some((product) => !product.loadedPrescription)) {
        let res = null
        let value = false
        let refundValue = 0
        let deductibleValue = 0

        if (isInsurance) {
          productList = productList.filter((prd) => prd.category_id !== null)
          if (productList.length == 0){
            refundSearch = false
            setTimeout(() => setLoadingInsurance(false), 500)
          }
        }

        if (refundSearch) {
          res = await getInsuranceLiquidation(
            props.insurance?.id,
            props.userData,
            item.pharmacy_chain_id,
            productList
          )

          refundValue = _.sumBy(res.data.liquidation, (product) => product.refund);
          deductibleValue = _.sumBy(res.data.liquidation, (product) => product.deductible);
          setDeductible(deductibleValue);
          setChainBusinessName(res.data.chain_business_name || 'la farmacia');
          setChainIdentityNumber(res.data.chain_identity_number || null);
          handleCheckTermsChange({ target: { checked: false }});

          if (item?.delivery.cost > 0 && (refundValue > 0 || deductibleValue > 0)) {
            setDeliveryDiscount(item?.delivery.cost > 0 && deliveryCode
              ? (deliveryCode.value * item?.delivery.cost) / 100
              : item?.delivery.cost)
          }
        }

        try {
          if (res?.data?.code_error !== 0) {
            setContext('Error Insurance', {
              ...res?.data,
              liquidation: JSON.stringify(res?.data?.liquidation),
            })
            Sentry.captureMessage('Error Refund Checked')
          }
        } catch (ignore) {}
        if (res?.data?.code_error === 5 || res?.data?.code_error === -1) {
          logEvent('Refund Checked', {
            Success: 'FALSE',
          })
          setInsuranceError(true)
        } else if ((res?.data?.code_error === 0) || (!refundSearch)) {
          let discountBenefits = 0
          let productAux = products
          try {
            if (refundSearch) {
              productAux?.map((c) => {
                let correlative = res?.data?.liquidation?.find((d) => {
                  if (c.product.client_product_id) {
                    return (
                      (d.product_id === c.product.count ||
                        d.product_id === c.product.internal_product_id) &&
                      ![undefined, null, ''].includes(d.product_id)
                    )
                  } else {
                    return false
                  }
                })
                if (correlative) {
                  c.product.refund = correlative.refund
                }
              })
            }
            discountBenefits = setProductDiscountBenefits(productAux)
          } catch (er) {
            console.log(er)
          }

          if (refundSearch) {
            value = _.find(res?.data?.liquidation, (product) =>
              ['Alcanza tope en UF'].includes((product.description || '').trim()),
            )
          }

          value && setInsurancePolicyLimit(true)
          dispatch(setApplicationNumber(res?.data?.request_id || null))

          setTotalCart(total - refundValue - discountBenefits)
          setStateToasts(true)
          setApplyRefund(true)
          setRefund({
            id: res?.data?.request_id || 0,
            value: refundValue,
          })

          logEvent('Refund Checked', {
            Success: (refundValue > 0 || deductibleValue > 0) ? 'TRUE' : 'FALSE',
            Subtotal: total,
            Refund: refundValue,
            'Total Pay': total - refundValue - clientDiscountBenefits,
            'Product Quantity': res?.data?.liquidation?.length,
            'Insurance Policy Limit': value > 0 ? 'TRUE' : 'FALSE',
            'Apply Deductible': deductibleValue > 0 ? 'TRUE' : 'FALSE'
          })
        }
        else if (res?.code_error === 1 || res?.data?.code_error === 2) {
          dispatch(setApplicationNumber(null))
          setInsurancePolicyLimit(res?.data?.error_message)

          logEvent('Refund Checked', {
            Success: 'TRUE',
            Subtotal: total,
            Refund: refundValue,
            'Total Pay': total - refundValue - clientDiscountBenefits,
            'Product Quantity': res?.data?.liquidation?.length,
            'Insurance Policy Limit': 'TRUE',
            'Apply Deductible': deductible > 0 ? 'TRUE' : 'FALSE',
          })
        }
      }
    } catch (ignore) {
      logEvent('Refund Checked', {
        Success: 'FALSE',
      })

      Sentry.captureException(ignore)
      Sentry.captureMessage('No fue posible calcular el valor de reembolso')
    } finally {
      refundSearch && setLoadingInsurance(false)
    }
  }

  function saveCheckoutTag(isSubscription, periodicity = 0) {
    let productQuantity = 0
    for (const product of products) {
      productQuantity += product.counter
    }

    let stepCompletedTag = {
      'Amount of Prescription Added': prescriptionProduct?.length,
      'Purchase Type': isSubscription ? 'Benefit Yapp' : 'Spot',
      'Product Quantity': productQuantity,
    }

    if (isSubscription) {
      stepCompletedTag.Periodicity = periodicity
    }

    logEvent('Checkout Step Completed', stepCompletedTag)
  }

  function loadedPrescription(quotation, skip) {
    return (
      prescriptionProduct?.find((product) => {
        if (
          ![undefined, null, ''].includes(quotation?.product?.client_product_id)
        ) {
          return (
            product?.product_id == quotation?.product?.product_id ||
            product?.product_id == quotation?.product?.client_product_id
          )
        } else {
          if (quotation?.product?.prescription_id === 0) {
            return true
          } else {
            return (
              product?.product_id == quotation?.product?.product_id ||
              product?.product_id == quotation?.product?.client_product_id
            )
          }
        }
      }) || []
    )
  }

  async function loadBeneficiaries(identity) {
    dispatch(setEnabledInsurance(false))
    setLoadingInsurance(true)
    setBenefit(null)

    let response = await getBeneficiaries(identity, props.insurance?.id)
    setLoadingInsurance(false)

    if (
      response?.message === 'OK: Success' &&
      response?.data?.listBeneficiaries?.length > 0
    ) {
      setOpenModalBeneficiaries(true)
      setBeneficiaries(response.data.listBeneficiaries)
    } else {
      props.setFormData({
        ...props.formData,
        full_name: {
          valid: false,
          value: _capitalize(''),
        },
        rut: {
          valid: true,
          value: '26.235.217-K',
        },
        titular_identity: {
          valid: true,
          value: '26.235.217-K',
        },
      })

      dispatch(setCopayUserData(''))
      dispatch(setApplicationNumber(null))
      setOpenModalError(true)
    }
  }

  async function onClickBenefit(userData) {
    setOpenModalBeneficiaries(false)

    if (userData) {
      let encryptedData = encrypt(userData)

      dispatch(setEnabledInsurance(true))
      props.setFormData({
        ...props.formData,
        full_name: {
          valid: true,
          value: _capitalize(userData?.name || ''),
        },
        rut: {
          valid: true,
          value: ![undefined, null, '', ' '].includes(userData?.identity)
            ? _validateRut(userData?.identity)
              ? _formatRut(userData?.identity)
              : null
            : null,
        },
        titular_identity: {
          valid: true,
          value: ![undefined, null, '', ' '].includes(
            userData?.identity_titular,
          )
            ? _validateRut(userData?.identity_titular)
              ? _formatRut(userData?.identity_titular)
              : null
            : null,
        },
      })

      dispatch(setCopayUserData(encryptedData))
    }
  }

  const inputRef = useRef(null)
  const modalSupplement = useRef(null)
  const modalTerms = useRef(null)
  const modalPrivacy = useRef(null)
  const modalInsurance = useRef(null)
  const modalHomeRef = useRef(null)
  return (
    <div className="">
      <ModalError
        isOpen={openModalError}
        setIsOpen={() => {
          setOpenModalError(false)
        }}
        title=""
        text="El rut no se encuentra registrado en esta plataforma, por favor intenta reembolsarlo manualmente..."
        btnText="Continuar sin reembolso"
      />
      <ModalBeneficiaries
        isOpen={openModalBeneficiaries}
        setIsOpen={() => {
          setOpenModalBeneficiaries(false)
        }}
        claimer={benefit}
        setClaimer={setBenefit}
        onClaimer={onClickBenefit}
        beneficiaries={beneficiaries}
        title="Selecciona el asegurado para quien se realizará la compra:"
        btnText="Aceptar"
      />
      <ModalUploader
        ref={modalRef}
        modalIsOpen={modalDocument}
        onSelect={setPrescriptionProduct}
      />
      <ModalUploadHome
        ref={modalHomeRef}
        closeModal={closeModalDocuments}
        modalIsOpen={modalDocument}
        setDocuments={setDocuments}
      />
      <Modal
        isOpen={modalErrorPayIsOpen}
        onAfterOpen={null}
        onRequestClose={retryModal}
        className="modal-custom"
        overlayClassName="modal-custom-bg"
        contentLabel="Modal1"
        ariaHideApp={false}>
        <div className="d-flex flex-column justify-content-center align-items-center">
          <img
            src={icErrorPay}
            alt="Error"
            className="mb-3"
            id="gtm-webapp-error-pay-method"
          />
          <p className="title-primary--xl text-center mb-30">
            Ha ocurrido un error con tu
            <br /> medio de pago.
          </p>
        </div>
        <div className="d-flex justify-content-center align-items-center flex-column">
          <Button
            className="btn-default--small btn-next mb-3"
            variant="primary"
            onClick={retryModal}>
            Volver a intentar
          </Button>
        </div>
      </Modal>
      {loadingInsurance &&
        (clientName !== 'Sura' ? (
          <LoadingScreen
            loading={true}
            bgColor="#f1f1f1"
            spinnerColor="var(--color-secondary)"
            textColor="var(--color-secondary)"
            text="Cargando información"></LoadingScreen>
        ) : (
          <LoadingSura />
        ))}
      {showPdf && (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js">
          <div className="bioequivalent-pdf">
            <button
              className="btn-circle-close"
              onClick={() => setShowPdf(false)}>
              <i className="icon-close"></i>
            </button>
            <Viewer
              fileUrl={pdfToShow}
              defaultScale={SpecialZoomLevel.PageWidth}
              /* defaultScale={0.5} */
              renderLoader={() => {
                return (
                  <img
                    src={loadingYapp}
                    alt="loading"
                    className="loading-yapp"
                  />
                )
              }}
            />
          </div>
          <div
            className="bioequivalent-pdf-lightbox"
            /* onClick={() => setShowPdf(false)} */
          ></div>
        </Worker>
      )}
      {loadingConfirmBuy ? (
        <LoadingCheckout prePay={isUserYapp === false} />
      ) : (
        <>
          {loadingGlobal ? (
            <div className="mt-4 mb-0 pt-5">
              <img
                src={loadingYapp}
                alt="loading"
                className="loading-yapp--alternative m-0"
              />
            </div>
          ) : (
            <>
              {clientName !== 'UC Christus' && (
                <div
                  id="gtm-webapp-wrap-checkout"
                  className="content-responsive d-flex justify-content-between py-3 px-md-0">
                  <div className="breadcrumbs c-pointer" onClick={goBack}>
                    <div className="d-flex align-items-center">
                      <i className="icon-chevron-right icon-reverse"></i>
                    </div>
                    <span
                      className="txt-4--regular-pr"
                      style={{color: 'var(--theme-color)'}}>
                      Volver
                    </span>
                  </div>
                </div>
              )}

              
              { clientName === 'Bice Vida' && (
                <div className="content-checkout content-responsive">
                  <div className="content-checkout-left">
                    <div className="d-flex justify-content-center align-items-center">
                      <img src={farmaciaFacil} className={"mw-100"} alt="Farmacia fácil" />
                    </div>
                  </div>
                </div>
              )}

              <div className="content-checkout content-responsive">
                <div className="content-checkout-left">
                  <h2 className="txt-2--bold-db mb-2">
                    Datos para el despacho
                  </h2>
                  <div className="mb-3">
                    <div className="d-flex flex-column flex-md-row">
                      <div className="mb-2 pr-md-2 position-relative w-md-50">
                        <Location 
                          externalLabel={isStyleLight} 
                          handleParentDeliveryCost={setDelivery} 
                          handleParentDeliveryDate={handleDeliveryDate}
                          handleParentLoading={setLoading}
                          pharmacy_chain_id={item?.pharmacy_chain_id} />
                      </div>
                      <div className="mb-2 w-md-50">
                        <Input
                          externalLabel={isStyleLight}
                          label="Número"
                          placeholder="Número (Ej: 2500)"
                          defaultValue={props.formData.location_number.value}
                          doChange={(value) =>
                            changeValue(value, 'location_number')
                          }
                          error={
                            formError?.location_number === false &&
                            !props.formData?.location_number?.value
                              ? {
                                  message:
                                    '* Necesitamos que ingreses un número de dirección para enviar tu pedido',
                                }
                              : !props.formData?.location_number?.valid &&
                                props.formData?.location_number?.value && {
                                  message:
                                    '* Necesitamos que ingreses un número de dirección para enviar tu pedido',
                                }
                          }
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="mb-2 pr-md-2 w-md-50">
                        <Input
                          externalLabel={isStyleLight}
                          label="Número dpto o casa"
                          placeholder="Número dpto o casa (Ej: dpto 15/ oficina 28)"
                          defaultValue={props.formData.address_additional.value}
                          doChange={(value) =>
                            changeValue(value, 'address_additional')
                          }
                        />
                      </div>
                      <div
                        className="mb-2 w-md-50"
                        onClick={() => inputRef.current.click()}>
                        {isStyleLight && (
                          <label className="txt-3--bold m-0 mb-2">
                            Fecha de entrega
                          </label>
                        )}
                        <div className="content-add-prescription pr-2">
                          <div className="position-relative w-100">
                            <p className="txt-5--regular-db">
                              {![null, undefined].includes(deliveryTime)
                                ? item?.delivery?.message
                                : moment(date).format('DD-MM-YYYY')}
                            </p>
                          </div>
                          <div className="d-flex align-items-center">
                            <p className="txt-paragraph">
                              +{_formatPrice(delivery?.cost)}
                            </p>
                            <i className="icon-chevron-right color-theme ml-2 c-pointer"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column flex-md-row">
                      <div className="mb-2 pr-md-2 w-md-50">
                        <Input
                          externalLabel={isStyleLight}
                          label="Teléfono"
                          placeholder="9XXXXXXXX"
                          maxLength={9}
                          type="tel"
                          codeArea="+56"
                          defaultValue={props.formData.phone.value}
                          error={
                            formError?.phone === false &&
                            !props.formData?.phone?.value
                              ? {
                                  message:
                                    '* Necesitamos un número de contacto en caso de tener problemas con el despacho.',
                                }
                              : (props.formData.phone.valid ||
                                  !errorPhoneEmpty) &&
                                !_validPhone(props.formData.phone.value) && {
                                  message:
                                    '* El número debe contener (9) caracteres.',
                                }
                          }
                          doChange={(value) => changeValue(value, 'phone')}
                          onKeyPress={removeErrorsPhone}
                        />
                      </div>
                      <div className="mb-2 w-md-50">
                        <Input
                          externalLabel={isStyleLight}
                          label="Correo"
                          placeholder="Ingresa tu correo"
                          defaultValue={props.formData.email.value}
                          error={
                            formError?.email === false &&
                            !props.formData?.email?.value
                              ? {
                                  message:
                                    '* Necesitamos un correo para enviarte información de seguimiento sobre tu pedido.',
                                }
                              : (!props.formData?.email?.valid || errorEmail) &&
                                props.formData?.email?.value && {
                                  message:
                                    '* Encontramos un error en el formato de tu correo, por favor verifica que esté correcto.',
                                }
                          }
                          doChange={(value) => changeValue(value, 'email')}
                          onKeyPress={removeErrorEmail}
                        />
                      </div>
                    </div>
                  </div>
                  { showInsurance && (
                    <>
                      <div className="d-flex align-items-center mb-3 mt-3">
                        <p className="title-primary--xl-bold mr-2">{titleInsurance}</p>
                        <i
                          data-tip={
                            isInsurance
                              ? 'Ingresa los datos del paciente para quien aplicará el seguro'
                              : 'Para validar tu seguro debes ingresar el rut del titular.'
                          }
                          data-for="tootip-payment-desktop"
                          className="icon-info-2 icon-size tooltip-hover"
                          style={{color: 'var(--theme-color)'}}></i>
                        <ReactTooltip
                          id="tootip-payment-desktop"
                          className="tooltip-style maxw-290"
                          effect="solid"
                          place="bottom"
                          arrowColor="#FFFFFF"
                          backgroundColor="white !important"
                        />
                        <i
                          data-tip={
                            isInsurance
                              ? 'Ingresa los datos del paciente para quien aplicará el seguro'
                              : 'Para validar tu seguro debes ingresar el rut del titular.'
                          }
                          data-for="tootip-payment-responsive"
                          data-event="click focus"
                          className="icon-info-2 icon-size tooltip-click"
                          style={{color: 'var(--theme-color)'}}></i>
                        <ReactTooltip
                          globalEventOff="click"
                          id="tootip-payment-responsive"
                          className="tooltip-style"
                          effect="solid"
                          place="right"
                          arrowColor="#FFFFFF"
                          backgroundColor="white !important"
                        />
                      </div>

                      { !isInsurance && (
                        <div className="mb-3">
                          <div className="d-flex flex-column flex-md-row">
                            <div className="mb-2 pr-md-2 w-md-50">
                              <SelectInsurance
                                externalLabel={isStyleLight}
                                label="Seleccionar aseguradora"
                                options={showInsuranceOptions()}
                                value={showDefaultInsuranceOption()}
                                onChange={(option) =>
                                  setLocalInsurance(option.value)
                                }
                                placeholder={'Selecciona un seguro'}
                              />
                            </div>
                            
                            {props?.insurance?.id !== null && (
                              <div className="mb-2 w-md-50">
                                <InputButton
                                  externalLabel={isStyleLight}
                                  label="Rut del titular"
                                  placeholder="Rut del titular"
                                  // hideButton={props?.enabledInsurance}
                                  btnText={
                                    props?.enabledInsurance
                                      ? 'Cambiar'
                                      : 'Validar'
                                  }
                                  // onFocus={resetTitular}
                                  value={
                                    props?.formData?.titular_identity?.value
                                  }
                                  onChange={(value) =>
                                    changeValue(value, 'titular_identity')
                                  }
                                  onButtonClick={() =>
                                    loadBeneficiaries(
                                      props.formData.titular_identity.value,
                                    )
                                  }
                                  error={
                                    formError?.titular_identity === false &&
                                    !props.formData?.titular_identity?.value
                                      ? {
                                          message:
                                            '* Necesitamos el RUT del títular.',
                                        }
                                      : !props.formData?.titular_identity
                                          ?.valid &&
                                        props.formData?.titular_identity
                                          ?.value && {
                                          message:
                                            '* El RUT debe contener entre 8 y 9 caracteres para ser válido.',
                                        }
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      <div className="d-flex align-items-center mb-3 mt-3">
                        <p className="txt-3--regular-db mr-2">Los datos del paciente deben coincidir con los datos de la receta</p>
                      </div>
                    </>
                  )}
                  <div className="mb-3">
                    <div className="d-flex flex-column flex-md-row">
                      <div className="mb-2 pr-md-2 w-md-50">
                        <InputButton
                          classData={tokenLogin ? 'input-disabled' : ''}
                          disabled={tokenLogin}
                          externalLabel={isStyleLight}
                          label="Rut"
                          placeholder="Rut"
                          hideButton={
                            (!isInsurance && !props?.enabledInsurance)
                            || false
                          }
                          btnText={
                            isInsurance ? 'Cambiar' : 'Validar'
                          }
                          value={props.formData.rut.value}
                          onButtonClick={() =>
                            loadBeneficiaries(props.formData.rut.value)
                          }
                          error={
                            formError?.rut === false &&
                            !props.formData?.rut?.value
                              ? {
                                  message:
                                    '* Necesitamos el RUT del paciente para validar la receta médica.',
                                }
                              : !props.formData?.rut?.valid &&
                                props.formData?.rut?.value && {
                                  message:
                                    '* El RUT debe contener entre 8 y 9 caracteres para ser válido.',
                                }
                          }
                          onChange={(value) => changeValue(value, 'rut')}
                        />
                      </div>
                      <div className="mb-2 w-md-50">
                        <Input
                          classData={tokenLogin ? 'input-disabled' : ''}
                          disabled={tokenLogin}
                          externalLabel={isStyleLight}
                          label="Nombre y apellido"
                          placeholder=""
                          defaultValue={props.formData.full_name.value}
                          error={
                            formError?.full_name === false &&
                            !props.formData?.full_name?.value && {
                              message:
                                '* Necesitamos el nombre del paciente para validar la receta médica. ',
                            }
                          }
                          doChange={(value) => changeValue(value, 'full_name')}
                        />
                      </div>
                    </div>
                  </div>
                  {isSubscription && (
                    <>
                      <h2 className="title-primary--xl-bold mb-2">
                        {textSubscriptionCheckout}
                      </h2>
                      <div className="d-flex">
                        <div className="w-75 mb-3">
                          <p className="txt-4--regular-db mb-2">Recibir cada</p>
                          <SimpleSelect
                            options={deliveryFrequencies}
                            value={frequency}
                            placeholder={'Selecciona tu frecuencia'}
                            onChange={setFrequency}
                            className="tablet-desktop"
                          />
                          {invalidFrequency && (
                            <p className="txt-6--regular-er mt-1 mb-2">
                              *Debes ingresar una frecuencia de entrega para
                              finalizar tu compra
                            </p>
                          )}
                          <div
                            onClick={() => setShowModalBottomSimple(true)}
                            className="btn-open-modal-bottom-full d-flex align-items-center justify-content-between px-3">
                            <div className="d-flex align-items-center justify-content-center w-100">
                              <p className="txt-5--regular-db pl-2">
                                {frequency?.label || 'Selecciona tu frecuencia'}
                              </p>
                            </div>
                            <i className="icon-chevron-down color-theme"></i>
                          </div>
                          <ModalBottomSimple
                            currentFrequency={frequency}
                            showModal={showModalBottomSimple}
                            onChange={setFrequency}
                            setShowModal={setShowModalBottomSimple}
                          />
                        </div>
                        {products.length > 0 && (
                          <div className="w-25 mb-3 pl-3">
                            <p className="txt-4--regular-db mb-2">Cantidad</p>
                            {products.map((item, index) => (
                              <Stepper
                                key={index.toString()}
                                counter={item.counter}
                                clickUpdateCounter={(quantity) =>
                                  setCounter(index, quantity)
                                }
                              />
                            ))}
                          </div>
                        )}
                      </div>
                    </>
                  )}

                  {products?.some((quotation) =>
                    requestPrescription(quotation),
                  ) && (
                    <h2 className="title-primary--xl-bold mb-2">
                      Receta médica
                    </h2>
                  )}
                  <div className="mb-3">
                    {/* AGREGAR PRODUCTOS */}
                    {products?.map((quotation, key) => {
                      let hasPrescription = loadedPrescription(quotation, true)
                      return (
                        <div key={key} className="p-0">
                          {requestPrescription(quotation) && (
                            <>
                              <ProductPrescription
                                product={quotation.product}
                                products={products.filter((quotation) =>
                                  requestPrescription(quotation),
                                )}
                                prescriptionProduct={prescriptionProduct}
                                onClickLoadPrescription={
                                  onClickLoadPrescription
                                }
                              />
                              {errorPrescription &&
                                hasPrescription?.length === 0 &&
                                quotation.product.prescription_id > 0 && (
                                  <p className="txt-6--regular-er">
                                    * Este medicamento requiere una receta
                                    médica, por favor agrega una para continuar.
                                  </p>
                                )}
                            </>
                          )}
                        </div>
                      )
                    })}
                    <>
                      {![null, undefined, ''].includes(
                        textExtraPrescription,
                      ) && (
                        <div className="mt-3">
                          <p className="txt-6--bold-db line-14">
                            {textExtraPrescription}
                          </p>
                        </div>
                      )}
                    </>
                  </div>
                  {isSubscription && (
                    <>
                      <h2 className="title-primary--xl-bold mb-2">
                        Ingresa tu código de descuento
                      </h2>
                      <div className="mb-3">
                        <InputButtonDiscount
                          discount={getCurrentDiscount()}
                          discountCode={discountCode}
                          setDiscountCode={setDiscountCode}
                          error={errorCode && {message: errorCode}}
                          onApply={onUseDiscountCode}
                          onRemove={() => setDiscount(null)}
                          defaultCodeForDiscount={defaultCodeForDiscount}
                        />
                      </div>
                    </>
                  )}
                </div>
                <div className="content-checkout-right pl-0 pr-0">
                  <h2 className="txt-2--bold-db">Resumen de tu compra</h2>
                  <div className="content-checkout-shopping-detail">
                    <div className="content-pay-detail">
                      <ProductSummary
                        title="Medicamentos"
                        buttonText="Agregar o quitar medicamentos"
                        modifyCart={!isSubscription}
                        totalCart={totalCart}
                        products={products.map((el) => {
                          return {
                            ...el.product,
                            ...el,
                            loadedPrescription:
                              requestPrescription(el) &&
                              loadedPrescription(el).length === 0,
                          }
                        })}
                        onClickAction={addProducts}
                        className="pt-2"
                        refundElement={refundElement}
                        onClickApplyRefund={onClickApplyRefund}
                        applyRefund={applyRefund}
                        discountRefund={getCurrentDiscount()}
                        clientDiscountBenefits={clientDiscountBenefits}
                        insurancePolicyLimit={insurancePolicyLimit}
                        insuranceError={insuranceError}
                        deductible={deductible}
                        refund={refund}
                        show={props.userData}
                        pressedButton={pressedButton}
                        showAlert={showAlert}
                        isSubscription={isSubscription}
                        deleteProduct={deleteProductItem}
                      />
                      {hasComplementary &&
                        productsComplementary?.length > 0 && (
                          <ProductSummary
                            title="Productos complementarios"
                            buttonText="Agregar o quitar productos complementarios"
                            products={productsComplementary}
                            discountRefund={getCurrentDiscount()}
                            modifyCart={true}
                            totalCart={totalComplementaryCart}
                            onClickAction={() =>
                              modalSupplement.current.openModal()
                            }
                          />
                        )}

                      <div className="d-flex flex-wrap content-checkout-delivery content-bg-white-resposive">
                        <h5 className="txt-4--bold-db mt-3 mb-3 w-100">
                          Despacho
                        </h5>
                        <div className="d-flex w-100 justify-content-between mb-3">
                          <p className="txt-paragraph--small" title={props?.commune?.name ?? ''}>
                            Costo despacho {!isSubscription && 'medicamentos'}
                          </p>
                          <p className="txt-5--regular-db">
                            {_formatPrice(delivery?.cost)}
                          </p>
                        </div>
                        {totalComplementaryCart > 0 &&
                          productsComplementary?.length > 0 && (
                            <div className="d-flex w-100 justify-content-between mb-3">
                              <p className="txt-5--regular-db">
                                Costo despacho productos complementarios
                              </p>
                              <p className="txt-5--regular-db">
                                {_formatPrice(complementaryDelivery?.cost)}
                              </p>
                            </div>
                          )}
                        {deliveryCode?.code && deliveryDiscount > 0 && (refund?.value > 0 || deductible > 0) && (
                          <div className="d-flex w-100 justify-content-between mb-3">
                            <p className="txt-5--regular-db">
                              Descuento especial Compañía de seguro
                            </p>
                            <p className="txt-5--regular-db">
                              -{_formatPrice(deliveryDiscount)}
                            </p>
                          </div>
                        )}
                      </div>
                      {getCurrentDiscount() > 0 && (
                        <div className="d-flex flex-wrap content-checkout-discount content-bg-white-resposive">
                          <div className="d-flex w-100 justify-content-between pt-2 pb-2">
                            <p className="txt-6--bold-db">
                              {discount?.short_name
                                ? discount.short_name
                                : 'Descuento aplicado'}
                            </p>
                            <p className="txt-6--bold-db">
                              - {_formatPrice(getCurrentDiscount())}
                            </p>
                          </div>
                        </div>
                      )}
                      <div
                        className="content-checkout-total-price content-bg-white-resposive"
                        style={{borderBottom: 0}}>
                        <div className="d-flex justify-content-between w-100">
                          <h5 className="txt-4--bold-db  w-100">
                            Total a pagar
                          </h5>
                          <h5 className="txt-4--bold-db  ">
                            {_formatPrice(
                              totalCart +
                                totalComplementaryCart +
                                delivery?.cost +
                                (totalComplementaryCart > 0
                                  ? complementaryDelivery?.cost
                                  : 0) -
                                getCurrentDiscount() -
                                (deliveryDiscount ? deliveryDiscount : 0),
                            )}
                          </h5>
                        </div>
                        <ProductSupplementary
                          ref={modalSupplement}
                          commune={props.commune}
                          setHasComplementary={(has) =>
                            setHasComplementary(has)
                          }
                          setComplementaryDelivery={(delivery) =>
                            setComplementaryDelivery(delivery)
                          }
                          closeModal={(payload) =>
                            setComplementaryCartValues(payload)
                          }
                          onCloseModal={clickGenerateLink}
                          clickShowPdf={(pdf) => {
                            setPdf(pdf)
                            setShowPdf(true)
                          }}
                        />
                      </div>
                      {userInfo && userInfo?.signInMethod !== 'anonymously' && (
                        <div
                          className={
                            'content-checkout-total-price content-bg-white-resposive flex-column hr-bottom-none'
                          }>
                          <div className="d-flex align-items-center mb-2 mt-2">
                            <p className="txt-4--bold-db mr-2">
                              Método de pago
                            </p>
                            <i
                              data-tip="Para eliminar o modificar tu tarjeta deberás ingresar a la App de Yapp."
                              data-for="tootip-payment-desktop"
                              className="icon-info-2 icon-size tooltip-hover"
                              style={{color: 'var(--theme-color)'}}></i>
                            <ReactTooltip
                              id="tootip-payment-desktop"
                              className="tooltip-style maxw-290"
                              effect="solid"
                              place="bottom"
                              arrowColor="#FFFFFF"
                            />
                            <i
                              data-tip="Para eliminar o modificar tu tarjeta deberás ingresar a la App de Yapp."
                              data-for="tootip-payment-responsive"
                              data-event="click focus"
                              className="icon-info-2 icon-size tooltip-click"
                              style={{color: 'var(--theme-color)'}}></i>
                            <ReactTooltip
                              globalEventOff="click"
                              id="tootip-payment-responsive"
                              className="tooltip-style"
                              effect="solid"
                              place="right"
                              arrowColor="#FFFFFF"
                            />
                          </div>

                          {loading ? (
                            <div className="mt-4 mb-0">
                              {' '}
                              <img
                                src={loadingYapp}
                                alt="loading"
                                className="loading-yapp--alternative m-0"
                              />{' '}
                            </div>
                          ) : (
                            <div>
                              {creditCards.length > 0 && (
                                <SelectPaymentMethod
                                  options={showPaymentOptions()}
                                  value={showDefaultPaymentOption()}
                                  onChange={(option) =>
                                    setPaymentMethod(option.value)
                                  }
                                  placeholder={'Selecciona un método de pago'}
                                  className="tablet-desktop maxw-290"
                                />
                              )}
                              {creditCards.length > 0 && (
                                <div
                                  onClick={() =>
                                    showPaymentOptions()
                                      ? setShowModalPaymentMethod(true)
                                      : null
                                  }
                                  className="btn-open-modal-bottom d-flex align-items-center justify-content-between px-3">
                                  {[null, undefined, false].includes(
                                    selectedPaymentMethod,
                                  ) ? (
                                    <p className="txt-5--bold-g1">
                                      Selecciona un método de pago
                                    </p>
                                  ) : (
                                    <div className="d-flex align-items-center">
                                      <div className="d-flex justify-content-center align-items-center">
                                        <img
                                          src={selectedPaymentMethod.logo}
                                          className="payment-logo"
                                          alt="Logo método de pago"
                                        />
                                      </div>
                                      <p className="txt-5--bold-db pl-2">
                                        {selectedPaymentMethod.last_four}
                                      </p>
                                    </div>
                                  )}
                                  <i className="icon-chevron-down color-theme"></i>
                                </div>
                              )}
                              <ModalSelectPaymentMethod
                                creditCards={creditCards}
                                setPaymentMethod={setPaymentMethod}
                                showModal={showModalPaymentMethod}
                                setShowModal={setShowModalPaymentMethod}
                              />

                              <div className="d-flex w-100 justify-content-center">
                                <ButtonYapp
                                  onClick={() => addPaymentMethod()}
                                  className={`maxw-214 ${
                                    creditCards.length > 0 ? ' mt-3' : 'mt-0'
                                  }`}
                                  disabled={false}
                                  color="--theme-color"
                                  stroke
                                  small
                                  title={'Agregar método de pago'}
                                />
                              </div>

                              {creditCards.length === 0 && (
                                <p className="txt-6--bold-er mt-1">
                                  * Para continuar con tu compra, necesitamos
                                  que ingreses un método de pago válido.
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    {!isUserYapp && (
                      <>
                        <div
                          className={
                            'd-flex align-items-center ' +
                            (errorCheckTerms ? 'mb-10' : ' mb-30')
                          }>
                          <label className="custom-checkbox">
                            <input
                              type="checkbox"
                              checked={props.formData.checkTerms.value}
                              onChange={handleCheckTermsChange}
                            />
                            <span className="checkmark">
                              <i className="icon-checkmark"></i>
                            </span>
                          </label>
                          <div>
                            <p className="txt-paragraph line-16">
                              Acepto los{' '}
                              <span className="color-theme c-pointer">
                                <span
                                  onClick={() =>
                                    modalTerms.current.openModal()
                                  }>
                                  Términos &amp; Condiciones
                                </span>
                              </span>
                              { isInsurance ? ', ' : ' y '}
                              <span className="color-theme c-pointer">
                                <span
                                  onClick={() =>
                                    modalPrivacy.current.openModal()
                                  }>
                                  Políticas de privacidad
                                </span>
                              </span>
                              { isInsurance && (
                                <>
                                  {', y '}
                                  <span className="color-theme c-pointer">
                                    <span
                                      onClick={() =>
                                        modalInsurance.current.openModal()
                                      }>
                                      Mandato Compañía de Seguros
                                    </span>
                                  </span>
                                </>
                              )}
                            </p>
                          </div>
                        </div>

                        {errorCheckTerms && (
                          <div className="mb-30">
                            <p className="txt-6--bold-er mt-1">
                              * Para continuar con tu compra, necesitamos que
                              aceptes los términos y condiciones.
                            </p>
                          </div>
                        )}
                      </>
                    )}
                    <div className="d-flex w-100 justify-content-center mt-2 mb-4 mb-md-3 mb-lg-0">
                      <ButtonYapp
                        className="px-5"
                        onClick={clickNextAction}
                        id="gtm-webapp-checkout-btn-go-pay"
                        title={isUserYapp ? 'Finalizar compra' : 'Ir a pagar'}
                        color={'--theme-color'}
                        big
                        disabled={purchase}
                      />
                    </div>
                    <ModalLegal
                      src={'https://landing.yapp.cl/terminos_responsivo'}
                      ref={modalTerms}
                    />
                    <ModalLegal
                      src={'https://landing.yapp.cl/privacidad_responsivo'}
                      ref={modalPrivacy}
                    />
                    <ModalLegal
                      insurance={chainBusinessName}
                      ref={modalInsurance}
                    />
                  </div>
                </div>
              </div>

              { clientName === 'Sura' &&
                <div className="d-flex justify-content-center align-items-center flex-row m-5 px-5 title-primary--regular text-center">
                  *El beneficio de Seguros SURA podrá consistir en reembolsos correspondiente al 
                  monto bonificado por Seguros SURA según su plan de seguro complementario que tenga contratado,
                  o al descuento otorgado por SEGUROS SURA para sus clientes, según corresponda.
                </div>
              }
            </>
          )}
        </>
      )}

      {clientName === 'Vida Security' && (
        <TypeSidetab 
          id='jjdc5aSF'
          buttonColor={'#282E55'}          
          buttonText={'Sugerencias'}
        />
      )}
      {clientName === 'Sura' && (
        <TypeSidetab
          id='wea0XraP'
          buttonColor={'#0033A0'}          
          buttonText={'Sugerencias!'}
        />
      )}

      <Application className="" theme={themeDateP}>
        <DatePicker
          ref={inputRef}
          style={{display: 'none'}}
          className="modal-datepicker-custom"
          value={date}
          minDate={minDate}
          onChange={checkDeliveryDate}
          formatStyle="large"
          locale={'es-CL'}
          isCentered={true}
        />
      </Application>
      {applyRefund && stateToasts && (
        <Toasts
          text="Reembolso/beneficio aplicado exitosamente"
          timer="5000"
          icon="icon-check"
          stateToasts={stateToasts}
          setStateToasts={setStateToasts}
        />
      )}
      {errorRefund && stateToasts && (
        <Toasts
          text="No se puede aplicar el reembolso"
          timer="5000"
          icon="icon-alert"
          color="var(--color-error-ds)"
          stateToasts={stateToasts}
          setStateToasts={setStateToasts}
        />
      )}
      {applyDiscount && (
        <Toasts
          text="Código aplicado exitosamente"
          timer="5000"
          icon="icon-check"
          stateToasts={applyDiscount}
          setStateToasts={setApplyDiscount}
        />
      )}
      {addNewCard && stateToasts && (
        <Toasts
          text="Método de pago agregado exitosamente"
          timer="5000"
          icon="icon-check"
          stateToasts={stateToasts}
          setStateToasts={setStateToasts}
        />
      )}
      {invalidDate && (
        <Toasts
          text={invalidDateMessage}
          timer="5000"
          icon="icon-alert"
          color="var(--color-error-ds)"
          stateToasts={stateToasts}
          setStateToasts={setInvalidDate}
        />
      )}
      {/* {invalidFrequency && (
        <Toasts
          text="Seleccione su frecuencia de envío"
          timer="5000"
          icon="icon-alert"
          color="var(--theme-color-secondary)"
          stateToasts={stateToasts}
          setStateToasts={setInvalidFrequency}
        />
      )} */}
    </div>
  )
}

const themeDateP = {
  rainbow: {
    palette: {
      brand: '#00a19b',
    },
  },
}

const mapStateToProps = (state) => {
  return {
    commune: state.app.commune,
    communes: state.delivery.communes,
    documents_pending: state.user.documents_pending,
    disabledThemeCheckout: state.app.config?.disabled_theme_checkout,
    config: state.app?.config,
    location: state.app?.location,
    formData: state.app?.formData,
    userData: state.user.copay_user_data,
    userInfo: state.user,
    holidayList: state.app?.holidayList,
    insuranceList: state.app?.insuranceList,
    insurance: state.user?.insurance,
    enabledInsurance: state.app?.enabledInsurance,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFormData: (formData) => dispatch(setFormData(formData)),
    setGoRouter: (router) => dispatch(setGoRouter(router)),
    setInsurance: (insurance) => dispatch(setInsurance(insurance)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ShoppingBagCheckout)